import { ToastContainer, cssTransition } from "react-toastify";
import { FiAlertCircle, FiAlertTriangle, FiCheck, FiInfo, FiX } from "react-icons/fi";
import "../../../assets/css/adminToasts.css";

const transition = cssTransition({ enter: "admin-toast-enter", exit: "admin-toast-exit", collapseDuration: 180 });

function ToastIcon({ type }) {
  const Icon = { success: FiCheck, error: FiAlertCircle, warning: FiAlertTriangle }[type] || FiInfo;
  return <span className="admin-toast-icon" aria-hidden="true"><Icon /></span>;
}

function CloseButton({ closeToast }) {
  return <button type="button" onClick={closeToast} className="admin-toast-close" aria-label="بستن پیام"><FiX aria-hidden="true" /></button>;
}

export default function AdminToastContainer() {
  return (
    <ToastContainer className="admin-toast-container" position="top-left" rtl limit={3}
      autoClose={5000} closeOnClick={false} pauseOnHover pauseOnFocusLoss draggable={false}
      icon={ToastIcon} closeButton={CloseButton} transition={transition} />
  );
}
